import React from 'react';
import PropTypes from 'prop-types';

const PAST_DUE_MESSAGE = 'Update your billing info to resume Power and access all your membership benefits.';

const FableticsPastDueMessage = ({ hasPastDueSubscription, className, testId }) => {
    if (!hasPastDueSubscription) {
        return null;
    }
    return <p className={className} data-testid={testId}>{PAST_DUE_MESSAGE}</p>;
};

FableticsPastDueMessage.propTypes = {
    hasPastDueSubscription: PropTypes.bool.isRequired,
    className: PropTypes.string,
    testId: PropTypes.string,
};

FableticsPastDueMessage.defaultProps = {
    className: null,
    testId: null,
};

export default FableticsPastDueMessage;
